var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-render"},[_c(_vm.widget.type,_vm._b({ref:_vm.widget.id,tag:"component",attrs:{"widget":_vm.widget,"model":_vm.model}},'component',Object.assign({}, _vm.$attrs),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }